import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Button, Modal, Input, Form } from "antd";
import { createWithdraw, getSubWithdraw } from '../../../actions/WithdrawAction';
import RegularExpression from '../../../constants/RegularExpression';

class WithdrawBtn extends React.Component {
    state = {
        isAddModalvisible: false,
    };

    showModal = () => {
        this.setState({ visible: true });
    };

    handleModalCancel = e => {
        this.props.form.resetFields();
        this.setState({ visible: false });
    };

    handleWithdraw = () => {
        const { affiliateId } = this.props.affiliates;
        const { form } = this.props;

        //Validate completed data
        form.validateFields((err, values) => {

            if (!err) {
                this.props.dispatch(createWithdraw(affiliateId, { ...values })).then((status) => {
                    if (status !== "error") {
                        this.handleModalCancel();
                        this.props.dispatch(getSubWithdraw(affiliateId, 1))
                    }
                })
            }

            form.resetFields();
        });
        this.handleModalCancel();
    };

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <React.Fragment>
                <Button type="primary" onClick={this.showModal}>{this.props.intl.messages.withdraw}</Button>
                <Modal
                    title={this.props.intl.messages.withdraw}
                    visible={this.state.visible}
                    onCancel={this.handleModalCancel}
                    centered
                    footer={[
                        <React.Fragment key='buttons'>
                            <Button onClick={this.handleModalCancel}
                                key="cancel">{this.props.intl.messages.cancel}</Button>
                            <Button onClick={this.handleWithdraw}
                                key="save" type="primary">{this.props.intl.messages.withdraw}</Button>
                        </React.Fragment>
                    ]}
                >
                    <Form>
                        <Form.Item label={this.props.intl.messages.amount}>
                            {getFieldDecorator('amount', {
                                rules: [
                                    { required: true, message: this.props.intl.messages.required_field },
                                    { pattern: RegularExpression.ONLY_NUMBERS, message: this.props.intl.messages.only_number }
                                ],
                            })(
                                <Input />
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.bank_name}>
                            {getFieldDecorator('bank_name', {
                                rules: [
                                    { required: true, message: this.props.intl.messages.required_field },
                                    { pattern: RegularExpression.ONLY_LETTERS, message: this.props.intl.messages.only_letters }
                                ],
                            })(
                                <Input />
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.sheba_number}>
                            {getFieldDecorator('sheba_number', {
                                rules: [
                                    { required: true, message: this.props.intl.messages.required_field },
                                    { pattern: RegularExpression.SHEBA_NUMBER, message: this.props.intl.messages.sheba_validation }
                                ],
                            })(
                                <Input />
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.account_number}>
                            {getFieldDecorator('account_number', {
                                rules: [{
                                    required: true,
                                    message: this.props.intl.messages.required_field,
                                }],
                            })(
                                <Input />
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.card_number}>
                            {getFieldDecorator('card_number', {
                                rules: [
                                    { required: true, message: this.props.intl.messages.required_field },
                                    { pattern: RegularExpression.CARD_NUMBER, message: this.props.intl.messages.card_number_validation }
                                ],
                            })(
                                <Input />
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.your_name}>
                            {getFieldDecorator('name', {
                                rules: [{
                                    required: true,
                                    message: this.props.intl.messages.required_field,
                                }],
                            })(
                                <Input />
                            )}
                        </Form.Item>

                    </Form>
                </Modal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        affiliates: state.affiliates
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(WithdrawBtn)));


// WEBPACK FOOTER //
// ./src/routes/subAffilate/Withdraw/WithdrawBtn.js